import { LanguageKeys } from 'src/common/constants/languages';

const ALL_LANGS: LanguageKeys[] = [LanguageKeys.en, LanguageKeys.hu, LanguageKeys.ro];

export const emptyLocalizedString = (): Record<LanguageKeys, string> => ({
  en: '',
  hu: '',
  ro: '',
});

export const filledLocalizedString = (value: string): Record<LanguageKeys, string> => ({
  en: value,
  hu: value,
  ro: value,
});

export function normalizeLocalizedString(
  value: string | Record<LanguageKeys, string> | undefined | null,
): Record<LanguageKeys, string> {
  if (value == null) {
    return emptyLocalizedString();
  }
  if (typeof value === 'string') {
    return filledLocalizedString(value);
  }
  return { ...emptyLocalizedString(), ...value };
}

/**
 * When every other language is still empty, the first edit copies the value to all languages.
 * After that, only the active language is updated.
 */
export function updateLocalizedStringWithInitialSync(
  current: Record<LanguageKeys, string>,
  lang: LanguageKeys,
  value: string,
): Record<LanguageKeys, string> {
  const othersEmpty = ALL_LANGS.filter(l => l !== lang).every(l => !current[l]?.trim());
  if (othersEmpty) {
    return filledLocalizedString(value);
  }
  return { ...current, [lang]: value };
}
